import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const EffortlessPaymentIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3819_26263)">
      <path
        d="M14.209 43.9165C16.3491 43.9165 18.084 42.1816 18.084 40.0415C18.084 37.9014 16.3491 36.1665 14.209 36.1665C12.0689 36.1665 10.334 37.9014 10.334 40.0415C10.334 42.1816 12.0689 43.9165 14.209 43.9165Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M49.0833 7.75H12.9167C9.49221 7.7541 6.20919 9.11628 3.78773 11.5377C1.36628 13.9592 0.00410197 17.2422 0 20.6667L0 41.3333C0.00410197 44.7578 1.36628 48.0408 3.78773 50.4623C6.20919 52.8837 9.49221 54.2459 12.9167 54.25H49.0833C52.5078 54.2459 55.7908 52.8837 58.2123 50.4623C60.6337 48.0408 61.9959 44.7578 62 41.3333V20.6667C61.9959 17.2422 60.6337 13.9592 58.2123 11.5377C55.7908 9.11628 52.5078 7.7541 49.0833 7.75ZM12.9167 12.9167H49.0833C51.1388 12.9167 53.11 13.7332 54.5634 15.1866C56.0168 16.64 56.8333 18.6112 56.8333 20.6667H5.16667C5.16667 18.6112 5.98318 16.64 7.43659 15.1866C8.89 13.7332 10.8612 12.9167 12.9167 12.9167ZM49.0833 49.0833H12.9167C10.8612 49.0833 8.89 48.2668 7.43659 46.8134C5.98318 45.36 5.16667 43.3888 5.16667 41.3333V25.8333H56.8333V41.3333C56.8333 43.3888 56.0168 45.36 54.5634 46.8134C53.11 48.2668 51.1388 49.0833 49.0833 49.0833Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
    </g>
    <defs>
      <clipPath id="clip0_3819_26263">
        <rect width="62" height="62" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
